<template>
  <div class="animated fadeIn update-inventory-page">
    <b-row>
      <b-col>
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="card-wrap"
          >
            <component-new-header
              title="Update Inventory"
              :hasSearch="false"
              :hasReload="false"
              :hasRadio="false"
              :hasCreate="false"
              :hasback="false"
            />

            <!-- Section 1: Warehouse & Item Selection -->
            <div class="section-block">
              <b-row class="align-items-center">
                <b-col cols="12" sm="12" md="5" class="field-col">
                  <label class="field-label">Warehouse</label>
                  <b-form-group class="mb-0">
                    <eb-select
                      type="text"
                      :options="stockOptions"
                      label="label"
                      placeholder="Select Warehouse"
                      @input="changeStockpoint"
                    ></eb-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="5" class="field-col">
                  <label class="field-label">Item</label>
                  <b-form-group class="mb-0">
                    <eb-select
                      type="text"
                      :options="itemList"
                      label="label"
                      placeholder="Select Item"
                      @input="changeItem"
                    ></eb-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="2" class="field-col btn-col">
                  <b-button
                    variant="primary"
                    :disabled="!itemId || itemId === ''"
                    @click="downloadTemplate"
                    class="action-btn w-100"
                  >
                    <b-icon icon="download" class="mr-1"></b-icon>
                    Download Template
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <div class="section-divider"></div>

            <!-- Section 2: File Upload -->
            <div class="section-block">
              <b-row class="align-items-center">
                <b-col cols="12" sm="12" md="10" class="field-col">
                  <label class="field-label">Upload Template File</label>
                  <b-form-file
                    placeholder="Select a Template (.xls)"
                    @change="selectFile"
                    drop-placeholder="Drop file here..."
                    class="file-input"
                  ></b-form-file>
                </b-col>

                <b-col cols="12" sm="12" md="2" class="field-col btn-col">
                  <b-button
                    variant="primary"
                    :disabled="!itemId || itemId === ''"
                    @click="uploadFile"
                    class="action-btn w-100"
                  >
                    <b-icon icon="cloud-upload-fill" class="mr-1"></b-icon>
                    Update Inventory
                  </b-button>
                </b-col>
              </b-row>
            </div>

          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import componentNewHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select";

export default {
  name: "UpdateInventory",
  components: {
    ebSelect,
    loader,
    componentNewHeader,
  },
  data: () => ({
    loading: false,
    itemId: "",
    providerId: "",
    stockPointId: "",
    selectedFile: null,
  }),
  methods: {
    ...mapActions({
      GetStockpoints: "partner/fetchStockpointsByTenant",
      GetItems: "item/fetchItemsByCatalog",
      DownloadTemplate: "inventory/downloadInventoryTemplate",
      UploadFile: "inventory/uploadFileToStorage",
      UpdateInventory: "inventory/updateInventory",
    }),
    changeStockpoint(data) {
      if (data !== null) {
        this.loading = true;
        this.providerId = data.providerId;
        this.stockPointId = data._id;
        let payload = { needInventory: true };
        if (this.userCategory === "MANUFACTURER") {
          payload.manufacturerId = this.$store.getters["auth/getUserID"];
        } else {
          payload.provider = data.providerId;
        }
        this.GetItems(payload)
          .then(() => (this.loading = false))
          .catch(() => (this.loading = false));
      }
    },
    changeItem(data) {
      this.itemId = data._id;
    },
    downloadTemplate() {
      this.loading = true;
      this.DownloadTemplate(this.itemId)
        .then((res) => {
          this.loading = false;
          const element = document.createElement("a");
          element.setAttribute(
            "href",
            window.URL.createObjectURL(new Blob([res]))
          );
          element.setAttribute("download", `${this.itemId}_template.xls`);
          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        })
        .catch(() => (this.loading = false));
    },
    selectFile(event) {
      setTimeout(() => {
        this.selectedFile = event.target.files[0];
      }, 500);
    },
    async uploadFile() {
      let formdata = new FormData();
      formdata.append("file", this.selectedFile);
      formdata.append(
        "key",
        (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase()
      );
      formdata.append("isPublic", true);
      formdata.append("replaceExisting", true);
      formdata.append("basePath", "inventory");
      await this.UploadFile(formdata)
        .then((res) => {
          this.updateInventory(res.data.fileUrl);
        })
        .catch(() => {
          this.$swal({
            type: "error",
            text: "File Upload failed! please try again.",
          });
          this.loading = false;
        });
    },
    updateInventory(fileUrl) {
      let payload = {
        itemId: this.itemId,
        providerId: this.providerId,
        stockPointId: this.stockPointId,
        fileUrl: fileUrl,
      };
      this.UpdateInventory(payload)
        .then(() => {
          this.loading = false;
          this.$swal({
            type: "success",
            text: "Inventory Updated Successfully!",
          });
        })
        .catch(() => (this.loading = false));
    },
  },
  computed: {
    stockOptions() {
      let data = this.$store.getters["partner/GetAllStockPointList"];
      let userId = this.$store.getters["auth/getUserID"];
      if (data.length > 0) {
        return data.map((obj) => ({
          _id: obj._id,
          providerId: userId,
          label: obj.office?.officeName || "",
        }));
      }
      return [];
    },
    itemList() {
      let data = this.$store.getters["item/GetItemListByCatalog"];
      if (data.length > 0) {
        return data.map((obj) => ({
          _id: obj._id,
          label: obj.description_summary,
        }));
      }
      return [];
    },
    userCategory() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
    },
  },
  async mounted() {
    await this.$store.dispatch("partner/fetchAllStockPointTenant");
  },
};
</script>

<style lang="sass" scoped>
.update-inventory-page
  padding: 0.5rem

.card-wrap
  min-height: 400px
  border-radius: 8px
  overflow: hidden

.section-block
  padding: 1rem 0.5rem
  border-radius: 6px

.section-label
  font-size: 0.75rem
  font-weight: 700
  text-transform: uppercase
  letter-spacing: 0.08em
  color: #6c757d
  margin-bottom: 0.85rem
  padding-bottom: 0.4rem
  border-bottom: 1px dashed #dee2e6

.section-divider
  border-top: 1px solid #e9ecef
  margin: 0.25rem 0

.field-col
  margin-bottom: 0.75rem

  @media (min-width: 768px)
    margin-bottom: 0

.field-label
  display: block
  font-size: 0.8rem
  font-weight: 600
  color: #495057
  margin-bottom: 0.35rem

.btn-col
  display: flex
  align-items: flex-end

  @media (max-width: 767px)
    align-items: stretch

.action-btn
  height: 38px
  font-size: 0.85rem
  font-weight: 600
  white-space: nowrap
  display: flex
  align-items: center
  justify-content: center
  gap: 0.3rem

  @media (max-width: 767px)
    width: 100% !important
    margin-top: 0.25rem

.file-input
  height: 38px

.b-form-group
  margin-bottom: 0 !important
</style>